export function updateNavigation(path, append = false) {
  let newUrl = `${path}`;

  if (append) {
    newUrl = `${window.location.pathname}${path}`;
  }

  window.history.pushState({}, '', newUrl);
  window.dispatchEvent(new Event('popstate'));
}

/**
 * Replace placeholders in a path with their corresponding values.
 *
 * @param {string} path - The path containing placeholders.
 * @param {Object} placeholders - An object containing the placeholders and their values.
 * @returns {string} The path with all placeholders replaced.
 */
export function replacePathPlaceholders(path, placeholders) {
  let newPath = path;
  Object.keys(placeholders || {}).map((key, index) => {
    newPath = newPath.replaceAll(`:${key}`, placeholders[key]);
    return newPath;
  });
  return newPath;
}
